import React from 'react';
import Carousel from '../partials/Carousel';
import ItemList from '../partials/ItemList';
import BannerLarge from '../partials/BannerLarge';
import PostPreview from '../posts/PostPreview';
import ProductsPrev from '../product/ProductsPrev';
import ProductItem from '../product/ProductItem';
import ButtonMore from '../partials/ButtonMore';
import API from '../../configAPI';
import CONFIG from '../../config';

class HomePage extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            items : [],
            posts:[],
            products_oferta : [],
            providers2: {
                data: [],
                current_page: 1,
                total: 0,
                last_page: 1
            },
        }
    }

    componentDidMount(){
        document.title = CONFIG.app_title ;
        this.getItems();
        this.getPosts();
        this.getProviders2();
        this.getProdOferta();
        window.scrollTo(0,0);
    }

    getItems = () =>{
        API.PRODUCTS('items?limit=20')
        .then(resp => {
            
            this.setState({
                items: resp.data
            });
        })
        .catch(err => {
            console.log(err);
        });
    }
    getPosts = () =>{
        API.PRODUCTS('posts?limit=2')
        .then(resp =>{
            console.log(resp);
            this.setState({
                posts : resp.data
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }
    getProviders2 = () => {
        API.PRODUCTS(`providersp2?limit=9`)
         .then(resp =>{
             this.setState({
                 providers2 : resp.data,
                 loading: !this.state.loading
             });
 
         })
         .catch(err =>{
             this.setState({
                 loading: !this.state.loading
             });
             console.log(err);
         });
     }

     getProdOferta = () => {
        API.PRODUCTS('products/oferta')
         .then(resp =>{
             this.setState({
                 products_oferta  : resp.data,
                 loading: !this.state.loading
             });
             //console.log(resp.data);
 
         })
         .catch(err =>{
             this.setState({
                 loading: !this.state.loading
             });
             console.log(err);
         });
     }
    render(){
        return(
            <div>
                <Carousel/>
                <div className="container-fluid mt-3 mb-3">
                    <div className="col-12">
                        <BannerLarge 
                            url="https://expodeco.pe/"
                            image="https://dossierdearquitectura.com/banner/expodeco2020-arqui.gif"
                            title="Expodeco 2020"
                        />
                        <h4>Categorías</h4>
                        <ItemList items={this.state.items}/>
                        <div className="d-flex pt-3 pb-3 justify-content-center">
                            <ButtonMore href="/productos"/>
                        </div>
                        <BannerLarge 
                            url="https://dossierdearquitectura.com/"
                            image="https://dossierdearquitectura.com/banner/da728x160.jpg"
                            title="Visite Dossier de Arquitectua"
                        />
                         <div className="mt-2 mb-2">
                            <h4>Ofertas destacadas</h4>
                            <div className="row d-flex flex-wrap mt-3">
                                <ProductItem products={this.state.products_oferta}/>
                            </div>
                        </div>
                        

                        <div className="mt-2 mb-2">
                            <h4>Últimas noticias</h4>
                            <PostPreview posts={this.state.posts}/>
                            <div className="d-flex pt-3 pb-3 justify-content-center">
                                <ButtonMore href="/noticias"/>
                            </div>
                        </div>
                        <div className="mt-2 mb-2">
                            <h4>Nuestras sugerencias</h4>
                            
                            <ProductsPrev/>
                        
                        </div>
                        <div className="d-flex pt-3 pb-3 justify-content-center">
                            <ButtonMore href="/productos"/>
                        </div>

                        <div className="mt-2 mb-2">
                            <h4>Lista de Marcas</h4>
                            
                            <div class="col-12 mx-auto">
                            <div class="row row-cols-1 row-cols-md-3">
                            {this.state.providers2.data.map((prov,index) =>(
                            
                            <div class="card" key={index} >
                                <div class="row">
                                <div class="col-md-4">
                                <a href={`/empresa/${prov.slug}`} class="text-center"><img src={prov.url_logo} class="card-img mx-auto" style={{margin:"15% 0 0 0"}} alt={prov.name}></img></a>
                                                        
                                </div>
                                <div class="col-md-8">
                                <div class="card-body">
                                    <h5 class="card-title text-center">{prov.name}</h5>
                                    <p class="card-text text-center">{prov.products_count} productos</p>
                                                            
                                </div>
                                </div>

                                </div>
                                </div>
                            
                                ))}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex pt-3 pb-3 justify-content-center">
                            <ButtonMore href="/empresas"/>
                        </div>
                        <BannerLarge 
                            url="https://plataforma.constructivo.com/arquitectura"
                            image="https://constructivo.com/banners/plataforma728x160.jpg"
                            title="Capacítate en cualquier momento. Ingresa a Plataforma CONSTRUCTIVO"
                        />
                    </div>
                </div>
            </div>
        )
    }
}
export default HomePage;